// File generated from our OpenAPI spec
import { StripeResource } from '../StripeResource.js';
const stripeMethod = StripeResource.method;
export const Tokens = StripeResource.extend({
    create: stripeMethod({ method: 'POST', fullPath: '/v1/tokens' }),
    retrieve: stripeMethod({ method: 'GET', fullPath: '/v1/tokens/{token}' }),
});
